import { requestOTP, submitOTP, login, signup } from 'api/auth';
// import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

function useRequestOTP() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(requestOTP, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('کد ورود به شماره شما ارسال شد', { variant: 'success' }),
  });
}

function useSubmitOTP(){
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(submitOTP, {
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('شما با موفقیت وارد شدید.', { variant: 'success' }),
  });
}

function useLogin() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(login, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

function useSignup() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(signup, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}


export {useRequestOTP, useSubmitOTP, useLogin, useSignup };
